import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";
import "datatables.net-responsive-dt";
import "datatables.net-select-dt";
import React, { useState, useEffect, useRef, useContext } from "react";
import { format } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { getAllUsers, updateStatusUser, updateRole, deleteUser } from "../../../redux/userSlice/userSlice";
import notify from "../../../hooks/useNotifaction";
import { ROLES } from "../../../constants/roles";
import { AuthContext } from "../../../context/AuthContext";

DataTable.use(DT);

export default function User() {
  const [users, setUsers] = useState([]);
  const dispatch = useDispatch();
  const { allUsers, status, pagination } = useSelector((state) => state.user);
  const table = useRef();
  const [loading, setLoading] = useState(true);
  const { user, role } = useContext(AuthContext);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState("");

  useEffect(() => {
    dispatch(getAllUsers({ page: currentPage, status: true }));
  }, [currentPage]);

  useEffect(() => {
    if (allUsers) {
      setTotalPages(Math.ceil(pagination.total / pagination.limit));
      const filteredUser = allUsers?.filter((uu) => uu.id !== user.id && uu.role !== ROLES.OWNER);

      setUsers(filteredUser);
      setLoading(false);
    }
  }, [allUsers]);

  const handleAccept = async (userId, role) => {
    try {
      setLoading(true);
      await dispatch(updateStatusUser({ id: userId, data: { status: "active" } }));
      await dispatch(updateRole({ id: userId, data: { role } }));
      await dispatch(getAllUsers({ page: currentPage, status: true }));
      notify("تم قبول المستخدم وتعيين الصلاحية", "success");
    } catch (err) {
      console.error(err);
      notify("حدث خطأ أثناء قبول المستخدم", "error");
    }
    setLoading(false);
  };

  const handleUpdateRole = async (userId, role) => {
    try {
      setLoading(true);
      await dispatch(updateRole({ id: userId, data: { role } }));
      notify("تم تعديل الصلاحية بنجاح", "success");
    } catch (err) {
      console.error(err);
      notify("حدث خطأ أثناء تعديل الدور", "error");
    }
    setLoading(false);
  };

  const handleDeleteUser = (userId) => {
    console.log(userId)
    Swal.fire({
      title: "هل أنت متأكد؟",
      text: "لا يمكنك التراجع بعد الحذف!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "نعم، احذفه",
      cancelButtonText: "إلغاء",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          await dispatch(deleteUser(userId));
          notify("تم حذف المستخدم", "success");
        } catch (err) {
          console.error(err);
          notify("حدث خطأ أثناء الحذف", "error");
        }
        setLoading(false);
      }
    });
  };

  const columns = [
    { title: "الاسم", data: "name" },
    { title: "البريد الإلكتروني", data: "email" },
    { title: "رقم الهاتف", data: "phone" },
    { title: "الدور", data: "role" },
    { title: "الحالة", data: "status" },
    {
      title: "تاريخ الإنشاء",
      data: "createdAt",
      render: (data) => format(new Date(data), "yyyy-MM-dd"),
    },
    {
      title: "الإجراءات",
      data: null,
      createdCell: (td, cellData, rowData) => {
        const roles = Object.values(ROLES);
        const filteredRoles = role === ROLES.OWNER ? roles : roles.filter((r) => r !== ROLES.OWNER);

        const selectHtml = `
    <select class="form-select role-select" data-id="${rowData.id}" style="width: 120px; display: inline-block;">
      <option value="">اختر الصلاحية</option>
      ${filteredRoles.map((r) => `<option value="${r}" ${rowData.role === r ? "selected" : ""}>${r}</option>`).join("")}
    </select>
  `;

        const acceptBtn = rowData.status === "pending" ? `<button class="btn btn-success accept-btn" data-id="${rowData.id}" style="margin-right: 5px;">قبول</button>` : "";

        const updateRoleBtn = rowData.status !== "pending" ? `<button class="btn btn-primary update-role-btn" data-id="${rowData.id}" style="margin-right: 5px;">تعديل الصلاحية</button>` : "";

        const deleteBtn = `<button class="btn btn-danger delete-user-btn" data-id="${rowData.id}">حذف</button>`;

        td.innerHTML = `${acceptBtn} ${selectHtml} ${updateRoleBtn} ${deleteBtn}`;
      },
    },
  ];

  useEffect(() => {
    const handleClick = (event) => {
      const acceptBtn = event.target.closest(".accept-btn");
      const updateBtn = event.target.closest(".update-role-btn");
      const deleteBtn = event.target.closest(".delete-user-btn");

      if (acceptBtn) {
        const userId = acceptBtn.getAttribute("data-id");
        const selectElement = acceptBtn.closest("td").querySelector(".role-select");
        const selectedRole = selectElement?.value;
        if (selectedRole) {
          handleAccept(userId, selectedRole);
        } else {
          notify("يرجى اختيار صلاحية قبل القبول", "warning");
        }
      }

      if (updateBtn) {
        const userId = updateBtn.getAttribute("data-id");
        const selectElement = updateBtn.closest("td").querySelector(".role-select");
        const selectedRole = selectElement?.value;
        if (selectedRole) {
          handleUpdateRole(userId, selectedRole);
        } else {
          notify("يرجى اختيار صلاحية", "warning");
        }
      }

      if (deleteBtn) {
        const userId = deleteBtn.getAttribute("data-id");
        handleDeleteUser(userId);
      }
    };

    document.addEventListener("click", handleClick);
    return () => document.removeEventListener("click", handleClick);
  }, []);
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };
  return (
    <div className="main">
      <div>
        <h1 className="text-white text-center">المستخدمين</h1>
      </div>
      <div className="container-fluid">
        <div className="row justify-content-between align-items-center mt-3">
          <div className="col-md-4 d-flex justify-content-md-start justify-content-center mb-3">
            <div className="card py-2 px-3">
              <p className="mb-0 primary-100">عدد المستخدمين: {users?.length}</p>
            </div>
          </div>
        </div>

        <div className="table-responsive" style={{ overflowX: "auto" }}>
          <div>
            <p className="text-center mb-0 fs-5">بحث</p>
          </div>

          {users && users.length > 0 && (
            <DataTable
              options={{
                responsive: true,
                paging: false,
                searching: true,
              }}
              data={users}
              columns={columns}
              className="display table table-striped table-bordered"
              ref={table}
            />
          )}
          {totalPages > 1 && (
            <div className="row mt-4">
              <div className="col-12 d-flex justify-content-center">
                <nav>
                  <ul className="pagination">
                    <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                      <button className="page-link" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                        السابق
                      </button>
                    </li>
                    {[...Array(totalPages).keys()].map((page) => (
                      <li key={page + 1} className={`page-item ${currentPage === page + 1 ? "active" : ""}`}>
                        <button className="page-link" onClick={() => handlePageChange(page + 1)}>
                          {page + 1}
                        </button>
                      </li>
                    ))}
                    <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
                      <button className="page-link" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages}>
                        التالي
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
